export const describeTime = (timestamp: number) => {
    const days = Math.floor(timestamp / 86400)
    timestamp -= days * 86400
    const hours = Math.floor(timestamp / 3600) % 24
    timestamp -= hours * 3600
    const minutes = Math.floor(timestamp / 60) % 60
    timestamp -= minutes * 60
    const seconds = Math.floor(timestamp % 60)
    return [days, hours, minutes, seconds]
}